import Vue from 'vue';

let els;

if ((els = document.querySelectorAll('.newsletter-form')).length > 0) {
	for (let i = 0; i < els.length; i++) {
		const el = els[i];

		new Vue({
			el,
			name: 'NewsletterForm',
			data() {
				return {
					cities: [],
					opened: false,
					success: false,
					loading: false,
					email: ''
				}
			},
			methods: {
				sendForm() {
					this.loading = true;
					this.success = false;

					axios.post(this.$refs.form.attributes.getNamedItem('action').value, {
						email: this.email
					}).then((response) => {
						if (response.status === 200) {
							this.email = '';
							this.success = true;
						}

						this.loading = false;
					});
				}
			}
		});
	}
}
